import React, { useState, useEffect, useCallback, useRef } from "react";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import DraggableMarker from "./DraggableMarker";
import DropContainer from "./DropContainer";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";

export default function DifferenceFinder({
  imgSrc,
  onSetMarker,
  pointsLength,
  rightAnswer,
}) {
  const [markers, setMarkers] = useState([]);
  const imgRef = useRef(null);
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));

  useEffect(() => {
    if (rightAnswer) {
      const transformedData = JSON.parse(rightAnswer).map((item, index) => {
        const [x, y] = item.split("|").map(Number);
        return {
          id: index + 1,
          x: x * imgSize.width,
          y: y * imgSize.height,
        };
      });
      setMarkers(transformedData);
    }
  }, [rightAnswer]);

  useEffect(() => {
    const image = imgRef.current;
    if (image) {
      const handleLoad = () => {
        setImgSize({
          width: image.width,
          height: image.height,
        });
      };
      image.addEventListener("load", handleLoad);
      return () => {
        image.removeEventListener("load", handleLoad);
      };
    }
  }, [imgSrc]);

  useEffect(() => {
    let points = [];
    points = markers.map(
      (item) => `${item.x / imgSize.width}|${item.y / imgSize.height}`
    );
    onSetMarker(points);
  }, [markers]);

  const addMarker = useCallback(
    ({ x, y }) => {
      if (markers.length < pointsLength) {
        const newMarker = {
          id: markers.length + 1,
          x,
          y,
        };
        if (soudMuted) {
          TickAudio.play();
        }
        setMarkers((prevMarkers) => [...prevMarkers, newMarker]);
      } else {
        return;
      }
    },
    [markers]
  );

  const moveMarker = useCallback((id, x, y) => {
    setMarkers((prevMarkers) =>
      prevMarkers.map((marker) => {
        return marker.id === id ? { ...marker, x, y } : marker;
      })
    );
  }, []);

  return (
    <DndProvider backend={TouchBackend}>
      <DropContainer addMarker={addMarker} moveMarker={moveMarker}>
        <img
          ref={imgRef}
          crossOrigin="anonymous"
          src={imgSrc}
          alt="differenceFinder"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
        {markers.map((marker, index) => (
          <DraggableMarker
            key={marker.id}
            id={marker.id}
            position={{ x: marker.x, y: marker.y }}
            index={index}
            moveMarker={moveMarker}
          />
        ))}
      </DropContainer>
    </DndProvider>
  );
}
